class PoolTagDataModel {
  constructor(props) {
    this.id = String(props.id);
    this.name = props.name;
  }
}

export default PoolTagDataModel;
